var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaleAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 153 164",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-212.28 -289.42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(221.57 399)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 23.784c5.946-15.98 42.314-23.612 48.683-28.244 8.176-5.945 5.574-25.642 5.574-25.642l13.379 0.352 13.378-0.352s-2.601 19.697 5.575 25.642c6.368 4.632 42.737 12.264 48.683 28.244s8.175 30.102 8.175 30.102h-151.62s2.23-14.122 8.176-30.102",
    fill: "#ffc79c",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(305.06 368.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 21.972c-6.263-0.64-12.558-1.909-18.011-4.959-3.975-2.224-7.554-4.848-10.876-7.803 0.197-5.062-0.349-9.21-0.349-9.21l13.379 0.352 13.378-0.352s-1.851 14.018 2.479 21.972",
    fill: "#fcb285",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(220.51 424.91)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-2.345c5.792-15.566 40.235-23.268 48.304-27.978 6.374 3.706 14.146 5.891 22.544 5.891 7.297 0 14.123-1.649 19.969-4.511 11.311 4.814 40.19 12.464 45.449 26.598 5.99 16.097 8.236 30.323 8.236 30.323h-152.74s2.246-14.226 8.236-30.323",
    fill: "#5997c0",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.36 400.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-3.918 0.879 3.62 1.621-3.12 0.91 3.269s-1.786 0.149-5.806-0.298c-4.019-0.446 2.396-3.471 2.396-3.471",
    fill: "#cababa",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95122 .3085 .3085 -.95122 271.79 389.54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.317-2.343h19.448l-1.362-12.006-22.405 5.875 4.319 6.131z",
    fill: "#ffedee",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1644 .98639 .98639 -.1644 302.85 388.22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.068-14.344h12.166l-10.193 24.003-4.686-3.781 2.713-20.222z",
    fill: "#ffedee",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 570.05 368.78)"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m349.54 53.784c5.99 16.098 8.236 30.324 8.236 30.324h-152.74s2.246-14.226 8.236-30.324c5.259-14.133 34.138-21.783 45.449-26.597 5.847 2.862 12.672 4.51 19.97 4.51 8.397 0 16.17-2.184 22.543-5.891 8.069 4.711 42.512 12.413 48.304 27.978z",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.03,
    y: 55.612,
    width: 164,
    height: 20,
    fill: "#69b9e2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.21917 .97569 .97569 .21917 322 336.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3.534-9.795c-7.014 0.639-6.621 5.971-6.569 6.474-0.052 0.502-0.445 5.835 6.569 6.475 7.056 0.642 11.664-2.501 11.41-6.475 0.254-3.974-4.354-7.117-11.41-6.474",
    fill: "#fcb285",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.21919 -.97568 -.97568 .21919 257.08 336.89)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-3.534-9.795c7.014 0.639 6.621 5.971 6.569 6.473 0.052 0.503 0.445 5.836-6.569 6.475-7.056 0.643-11.664-2.5-11.41-6.474-0.254-3.974 4.354-7.117 11.41-6.474",
    fill: "#fcb185",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 1 1 0 299.82 310.26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m17.384-36.867c-29.387 2.678-27.741 25.019-27.52 27.126-0.221 2.107-1.867 24.448 27.52 27.126 29.563 2.693 48.87-10.474 47.808-27.126 1.062-16.652-18.245-29.82-47.808-27.126",
    fill: "#ffc79c",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.3 337.68)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 14.838c0.408-0.8 0.951-1.438 1.54-2.022 0.302-0.284 0.602-0.57 0.933-0.818 0.32-0.262 0.664-0.496 1.018-0.718l-0.163 0.437c-0.54-3.894-1.033-7.796-1.405-11.717 0.876 3.84 1.631 7.7 2.339 11.567l0.039 0.212-0.201 0.225c-0.279 0.311-0.568 0.609-0.88 0.88-0.301 0.284-0.635 0.531-0.965 0.78-0.676 0.481-1.398 0.908-2.255 1.174",
    fill: "#ed9d6d",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 302.14 336.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.835-1.835c-2.213 0-4.008 0.822-4.008 1.835s1.795 1.835 4.008 1.835 4.008-0.822 4.008-1.835-1.795-1.835-4.008-1.835",
    fill: "#352836",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 276.93 336.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.835-1.835c-2.213 0-4.008 0.822-4.008 1.835s1.795 1.835 4.008 1.835 4.008-0.822 4.008-1.835-1.795-1.835-4.008-1.835",
    fill: "#352836",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(308.48 326.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.688s-0.212-0.118-0.584-0.323c-0.18-0.099-0.399-0.219-0.651-0.357-0.246-0.13-0.524-0.277-0.827-0.437-0.313-0.134-0.626-0.314-0.976-0.452-0.34-0.16-0.7-0.304-1.073-0.433-0.363-0.161-0.759-0.22-1.135-0.353-0.391-0.04-0.775-0.189-1.166-0.174l-0.581-0.047c-0.191 0.023-0.383 0.029-0.574 0.04-0.388-0.017-0.749 0.128-1.124 0.174-0.373 0.059-0.708 0.24-1.059 0.332-0.359 0.085-0.648 0.298-0.96 0.417-0.296 0.147-0.6 0.253-0.828 0.412-0.235 0.148-0.459 0.264-0.642 0.365-0.371 0.197-0.605 0.303-0.605 0.303s0.096-0.222 0.302-0.599c0.105-0.187 0.231-0.42 0.397-0.672 0.147-0.272 0.38-0.52 0.644-0.789 0.273-0.257 0.519-0.611 0.905-0.835 0.377-0.231 0.751-0.543 1.219-0.717 0.47-0.16 0.947-0.406 1.484-0.441 0.264-0.036 0.532-0.078 0.801-0.102 0.269 3e-3 0.539 0.022 0.809 0.037 0.547 0.011 1.053 0.193 1.561 0.316 0.474 0.199 0.962 0.365 1.362 0.632 0.421 0.237 0.795 0.506 1.123 0.788 0.345 0.26 0.606 0.579 0.867 0.839 0.992 1.115 1.311 2.076 1.311 2.076",
    fill: "#352836",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(283.09 326.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.688s-0.212-0.118-0.584-0.323c-0.18-0.099-0.399-0.219-0.651-0.357-0.246-0.13-0.524-0.277-0.827-0.437-0.313-0.134-0.626-0.314-0.976-0.452-0.34-0.16-0.7-0.304-1.073-0.433-0.363-0.161-0.759-0.22-1.135-0.353-0.391-0.04-0.775-0.189-1.166-0.174l-0.581-0.047c-0.191 0.023-0.383 0.029-0.574 0.04-0.388-0.017-0.749 0.128-1.124 0.174-0.373 0.059-0.708 0.24-1.059 0.332-0.359 0.085-0.648 0.298-0.96 0.417-0.296 0.147-0.6 0.253-0.828 0.412-0.235 0.148-0.459 0.264-0.642 0.365-0.371 0.197-0.605 0.303-0.605 0.303s0.096-0.222 0.302-0.599c0.105-0.187 0.231-0.42 0.397-0.672 0.147-0.272 0.38-0.52 0.644-0.789 0.273-0.257 0.519-0.611 0.905-0.835 0.377-0.231 0.751-0.543 1.219-0.717 0.47-0.16 0.947-0.406 1.484-0.441 0.264-0.036 0.532-0.078 0.801-0.102 0.269 3e-3 0.539 0.022 0.809 0.037 0.547 0.011 1.053 0.193 1.561 0.316 0.474 0.199 0.962 0.365 1.362 0.632 0.421 0.237 0.795 0.506 1.123 0.788 0.345 0.26 0.606 0.579 0.867 0.839 0.992 1.115 1.311 2.076 1.311 2.076",
    fill: "#352836",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(298.94 361.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-3.334s-0.226 0.182-0.635 0.477c-0.205 0.146-0.455 0.323-0.741 0.525-0.282 0.21-0.603 0.439-1.009 0.615-0.393 0.197-0.822 0.411-1.286 0.623-0.454 0.246-0.978 0.344-1.505 0.515-0.533 0.146-1.075 0.351-1.661 0.384-0.579 0.064-1.167 0.152-1.758 0.195-0.593-0.031-1.186-0.063-1.77-0.094l-0.435-0.025-0.422-0.098c-0.278-0.066-0.553-0.131-0.824-0.195-0.54-0.13-1.066-0.234-1.52-0.473-0.467-0.201-0.9-0.403-1.296-0.591-0.41-0.157-0.723-0.427-1.014-0.63-0.287-0.208-0.537-0.389-0.743-0.538-0.407-0.301-0.627-0.483-0.627-0.483s0.277 0.101 0.739 0.297c0.229 0.099 0.507 0.219 0.825 0.357 0.321 0.129 0.66 0.315 1.076 0.41 0.407 0.116 0.844 0.241 1.298 0.387 0.446 0.177 0.956 0.208 1.464 0.303 0.515 0.061 1.03 0.228 1.577 0.207 0.541 0.017 1.091 0.035 1.641 0.053 0.549-0.029 1.097-0.101 1.638-0.147 0.545-0.022 1.065-0.158 1.574-0.269 0.498-0.136 1.022-0.162 1.46-0.344 0.448-0.156 0.881-0.289 1.284-0.414 0.813-0.23 1.463-0.586 1.93-0.759 0.466-0.192 0.74-0.288 0.74-0.288",
    fill: "#863f38",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(261.36 312.79)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 1.268c0 10.036 0.958 21.266 1.548 27.232 0.839-0.044 1.678-0.093 2.517-0.134l0.435-26.098c24.5 11 43.5-14 42.5-4s7 17.5 7 17.5l-0.608 11.548c1.361 1e-3 2.723 6e-3 4.084 0.01 1.853-9.157 4.712-24.994 4.024-32.558-1-11-9.5-8.5-9.5-8.5-4-12.5-30-1-38.5-5.5s-24-8-25.5 4.5 12 16 12 16",
    fill: "#352836",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(322.86 326.14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0-18.589c-1-11-9.5-8.5-9.5-8.5-0.988-3.087-3.321-4.707-6.398-5.469-0.122 5.358-0.773 10.699-2.098 15.723 2.502-1.105 3.774-1.034 3.496 1.746-1 10 7 17.5 7 17.5l-0.608 11.548c1.361 1e-3 2.723 6e-3 4.084 0.01 1.853-9.157 4.712-24.994 4.024-32.558",
    fill: "#1d161e",
    fillRule: "nonzero"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaleAvatar);
export default __webpack_public_path__ + "static/media/male_avatar.10c36af794eb5f173edcbfc70f4171f4.svg";
export { ForwardRef as ReactComponent };